import type { Pair } from '../messages';

/** The activity feed: event captions, the empty state and the people suggestions. */
export const feed = {
  'feed.kindCreated': ['новая подборка', 'new collection'],
  'feed.kindUpdated': ['обновили подборку', 'collection updated'],
  'feed.subtitle': ['Что публикуют те, на кого вы подписаны', 'What the people you follow publish'],
  'feed.findPeople': ['Найти людей', 'Find people'],
  'feed.emptyTitle': ['Здесь пока пусто', 'Nothing here yet'],
  'feed.emptyBody': [
    'Лента собирается из подборок авторов, на которых вы подписаны. Подпишитесь на кого-нибудь или соберите первую свою — она появится здесь же.',
    'The feed is made of collections by authors you follow. Follow someone, or build your first one — it lands right here.',
  ],
  'feed.createPlaylist': ['Создать подборку', 'Create a collection'],
  'feed.whoToRead': ['Кого прочитать', 'Who to follow'],
} satisfies Record<string, Pair>;
